/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useEffect, useMemo } from 'react';
import { Typography } from '@mui/material';
import { formatDate, RENEWAL_MAX_DAYS } from '@/utils/constants';
import { addDays, isAfter } from 'date-fns';
import { safelyParseDate } from '@/utils/date';

const PolicyRenewalDate = ({ ToDate }) => {
	const today = useMemo(() => new Date(), []);
	const renewalDate = safelyParseDate(ToDate);

	const showInRed = renewalDate && isAfter(today, renewalDate);
	const showInOrange =
		renewalDate && isAfter(today, addDays(renewalDate, -RENEWAL_MAX_DAYS)) && !showInRed;

	return (
		<Typography
			{...((showInRed || showInOrange) && {
				color: showInRed ? 'error' : 'warning',
			})}
		>
			{formatDate(ToDate, false)}
		</Typography>
	);
};

export default PolicyRenewalDate;
